import React from 'react'
import SpiderProducts from '../SpiderProducts'

/**
 * DigiKey 爬虫商品预览与正式产品导入模块。
 * @returns {JSX.Element} 固定 DigiKey 来源的导入页面
 */
const DigiKeySpiderProducts = () => <SpiderProducts fixedSource="digikey" />

export default DigiKeySpiderProducts
